module.exports = __webpack_public_path__ + "557d95943a37e577fb315982a288d87a.pdf";